import { Component, OnInit, Input } from '@angular/core';
import { Competition } from 'app/models/competition';

@Component({
  selector: 'app-competition-jumbotron',
  templateUrl: './competition-jumbotron.component.html',
  styleUrls: ['./competition-jumbotron.component.scss']
})
export class CompetitionJumbotronComponent implements OnInit {
  @Input('competition') competition: Competition;

  constructor() { }

  ngOnInit() {
  }
}
